import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Alert from "@material-ui/lab/Alert";
import  Divider from "@material-ui/core/Divider";
import _ from "lodash";
import { makeStyles } from "@material-ui/core/styles";
import getBrandFromUrl from "../../../utils/getBrandFromUrl";
import getCountryFromURL from "../../../utils/getCountryFromUrl";


//Material Icons
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

import { Button } from "@packages/ui";

import * as checkinActions from "src/actions/checkinActions";
// import { fontFamily } from "@mui/system";

const useStyles = makeStyles((theme) => ({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100vw",
        height: "100vh",
    },
    paper: {
        backgroundColor: "transparent",
        textAlign: "center",
    },
    iframe: {
        zIndex: 99,
        width: "100vw",
        height: "100vh",
    },
    loadingStatus: { position: "absolute", top: "50%", left: "50%", zIndex: "-1" },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },

    borderedTile: {
        border: "1px solid rgba(0, 0, 0, .6)",
        backgroundColor: "rgba(255, 204, 0, .1)",
        borderRadius: "5px",
        marginTop: "10px",
    },

    listItemText: {
        "& .MuiListItemText-primary": {
            fontFamily: 'Ride',
        },
        "& .MuiListItemText-secondary": {
            fontFamily: 'Ride',
        }
    },

    listItemAvatar: {
        minWidth: '40px'
    },

    divider: {
        margin: '2px 0 10px 0',
        height: '0.5px'
    },

    alert: {
        fontFamily: 'Ride',
        fontSize: '16px',
        "& .MuiAlert-icon": {display: 'none'}
    }
}));

const CCValidation = () => {
    const classes = useStyles();

    const checkin = useSelector((state) => state.checkin);
    const cardValidationStatus = useSelector((state) => state.checkin.windcave);

    const [iframeLoading, setIframeLoading] = React.useState(true);

    const open = cardValidationStatus.status === "validating";

    const dispatch = useDispatch();
    const brand = getBrandFromUrl();
    const country = getCountryFromURL();

    //Get URL PARAMETERS
    const status = new URLSearchParams(window.location.search).get("status");

    //* Request CC Validation with Windcave HPP
    const requestCardvalidation = async () => {
        dispatch(checkinActions.windcaveUpdate({ status: "validating" }));
        dispatch(checkinActions.extendSession());
        dispatch(
            checkinActions.requestWindcaveHpp({
                token: checkin.auth.token,
                brand: brand,
                country: country,
                resNo: checkin.reservation.ResNo,
            })
        );
    };

    React.useEffect(() => {
        if (!checkin.requireReVerifyCC && !checkin.isAdditionalDriver) {
            updateWindcaveStatus();
        }
    }, []);

    const updateWindcaveStatus = () => {
        dispatch(checkinActions.windcaveUpdate({ status: "finished" }));
        dispatch(
            checkinActions.requestWindcaveStatus({
                resNo: checkin.reservation.ResNo,
                brand: brand,
                country: country,
                token: checkin.auth.token,
            })
        );

        if (status !== null) {
            if (cardValidationStatus.Windcave !== undefined) {
                if (status.includes("APPROVED") && !cardValidationStatus.nameMisMatch) {
                    dispatch(
                        checkinActions.createToast({
                            type: "success",
                            message: `Credit Card Verified.`,
                        })
                    );
                }
                if (!status.includes("APPROVED")) {
                    dispatch(
                        checkinActions.createToast({
                            type: "error",
                            message: `Error. Credit Card details are invalid. Please contact your issuing bank before trying again. If you continue to experience issues please head to the counter on arrival to complete the check-in process.`,
                        })
                    );
                }
            }
        }
    }


    //* >>Continue to checkin btn function
    // const requestContinueCheckIn = () => {
    //     if (cardValidationStatus.Windcave?.status !== "APPROVED") {
    //         dispatch(
    //             checkinActions.createToast({
    //                 type: "error",
    //                 message: `Please Validate your Credit Card Details.`,
    //             })
    //         );
    //     }

    //     if (cardValidationStatus.Windcave?.status === "APPROVED") {
    //         navigate("/checkin/checkin-form", { replace: true });
    //     }
    // };

    const skipWindcave = () => {
        dispatch(checkinActions.windcaveSkip());
    };

    //* >>Loading screen for ifream loading..
    const iframeOnLoad = () => {
        setIframeLoading(false);
    };

    return (
        <React.Fragment>
            <div style={{ maxWidth: 600, padding: 20, height: "90vh" }}>
                <div>
                    <h2>Credit Card Verification</h2>
                    <p>Please verify your credit card details and ensure the name on the credit card matches the name on the reservation.</p>
                </div>

                <React.Fragment>
                    <div>
                        <List>
                            <ListItem className={classes.borderedTile} button onClick={requestCardvalidation} disabled={checkin.loading}>
                                <ListItemAvatar className={classes.listItemAvatar}>
                                    {cardValidationStatus.Windcave?.status.includes("APPROVED") && !cardValidationStatus.nameMisMatch ? (
                                        <CheckCircleOutlineIcon style={{ color: "green" }} />
                                    ) : (
                                        <ErrorOutlineIcon color="error" />
                                    )}
                                </ListItemAvatar>
                                <ListItemText className={classes.listItemText}
                                    primary="Credit Card Verification"
                                    secondary={
                                        (cardValidationStatus.Windcave?.status.includes("APPROVED") && !cardValidationStatus.nameMisMatch)
                                            ? "Status: Completed. Thank you for verifying your credit card details"
                                            : cardValidationStatus.nameMisMatch ? "Status: Card holder name does not match reservation name" : "Status: Pending Credit Card verification"
                                    }
                                />
                                <ListItemSecondaryAction>
                                    <IconButton
                                        edge="end"
                                        color="primary"
                                        aria-label="Validate"
                                        onClick={requestCardvalidation}
                                        disabled={checkin.loading}
                                    >
                                        <ArrowForwardIosIcon />
                                    </IconButton>
                                </ListItemSecondaryAction>

                            </ListItem>
                        </List>
                        {/* <Divider variant="middle" />
                        <Button
                            style={{ marginTop: 20, padding: 5, background: 'white' }}
                            fullWidth={false}
                            onClick={skipWindcave}
                            title={"PASS CC Validate"}
                            loading={checkin.loading}
                        /> */}
                    </div>
                </React.Fragment>

                <Divider className={classes.divider} />

                <Alert className={classes.alert} severity="info">Please note that card details are being used for verification only and are not stored.
                        You will still need to bring your card for payment when collecting your vehicle.</Alert>
            </div>

            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open}
                BackdropComponent={Backdrop}
            >
                <Fade in={open}>
                    <div className={classes.paper}>
                        <React.Fragment>
                            <div>{iframeLoading && <CircularProgress />}</div>
                            <div>{iframeLoading && <p>Validation in Process</p>}</div>

                            <div hidden={iframeLoading}>
                                <div className={classes.iframe}>
                                    <iframe
                                        src={checkin.windcave.Url}
                                        height="100%"
                                        width="100%"
                                        frameBorder="0"
                                        onLoad={iframeOnLoad}
                                    >
                                        Your browser doesnot support iframes
                    <a href={cardValidationStatus.Url}> click here to view the page directly. </a>
                                    </iframe>
                                </div>
                            </div>
                        </React.Fragment>
                    </div>
                </Fade>
            </Modal>

            <Backdrop className={classes.backdrop} open={open && !iframeLoading}>
                <CircularProgress color="primary" />
            </Backdrop>
        </React.Fragment>
    );
};

export default CCValidation;
